const PAIRING_CODE_DIGITS = 4;
const PAIRING_CODE_MODULO = 10 ** PAIRING_CODE_DIGITS;

const getHashBytes = async (value) => {
  const encodedValue = new TextEncoder().encode(value);
  if (!window.crypto?.subtle) return encodedValue;

  const digest = await window.crypto.subtle.digest("SHA-256", encodedValue);
  return new Uint8Array(digest);
};

const calculateHashNumber = (bytes) => {
  return bytes.reduce((total, byte) => (total * 31 + byte) % PAIRING_CODE_MODULO, 0);
};

export const createPairingCode = async ({ offerDescription, answerDescription }) => {
  const stableValue = JSON.stringify({
    offer: offerDescription?.sdp ?? "",
    answer: answerDescription?.sdp ?? "",
  });
  const hashBytes = await getHashBytes(stableValue);
  return String(calculateHashNumber(hashBytes)).padStart(PAIRING_CODE_DIGITS, "0");
};
